import Api from "@/apis/Api.js";

export default {
    search (term) {
        return Api.get(`/search?term=${term}`);
    }
}